import Header from "./component/header";
import Calculator from "./component/calculator";
import ContactUs from "./component/contactUs";

function App() {
    return <div className="App">
        <Header/>

        <main id="top">
            <section className="hero section">
                <div className="container hero-grid">
                    <div className="hero-copy">
                        <p className="eyebrow">Контакт360 · для клиник</p>
                        <h1>Сколько Вы можете заработать, если улучшить коммуникации с пациентами <span>по нашей методике?</span>
                        </h1>
                        <p className="hero-subtitle">5 минут Вашего времени и наш калькулятор покажет возможный
                            дополнительный доход.</p>
                        <a className="button button-primary" href="#calculator">Калькулятор <span>→</span></a>
                    </div>

                    <div className="hero-visual" aria-hidden="true">
                        <div className="visual-orbit orbit-one"></div>
                        <div className="visual-orbit orbit-two"></div>
                        <div className="income-card">
                            <p>Дополнительный доход<br/>в месяц</p>
                            <strong>~ 50 000 ₽</strong>
                            <small>Потенциально</small>
                            <div className="mini-chart">
                                <div className="bar b1"></div>
                                <div className="bar b2"></div>
                                <div className="bar b3"></div>
                                <div className="bar b4"></div>
                                <div className="bar b5"></div>
                                <div className="chart-line"></div>
                                <div className="chart-arrow">↗</div>
                            </div>
                        </div>
                        <div className="float-icon">☏</div>
                        <div className="float-icon second">₽</div>
                        <div className="float-icon third">▰</div>
                    </div>
                </div>
            </section>

            <Calculator />

            <section className="two-cards section" id="reports">
                <div className="container cards-grid">
                    <article className="info-card">
                        <div className="card-visual research-visual">
                            <span className="magnifier"></span><span className="circle c1"></span><span
                            className="circle c2"></span>
                        </div>
                        <div className="card-content">
                            <p className="eyebrow">Исследование</p>
                            <h2 id="research">Мы исследовали рынок Томска</h2>
                            <p>По результатам исследования 36 частных клиник Томска мы выявили системные проблемы в
                                коммуникациях, которые приводят к потере пациентов, денег и рабочего времени
                                администраторов.</p>
                            <div className="highlight">Ваша организация может эффективнее, чем конкурентам снится!</div>
                            <div className="button-row">
                                <a className="button button-outline" href="#research">Исследование</a>
                                <a className="button button-primary" href="#contacts">Хочу также</a>
                            </div>
                        </div>
                    </article>

                    <article className="info-card">
                        <div className="card-visual case-visual">
                            <div className="case-bars"><i></i><i></i><i></i><i></i><i></i></div>
                            <div className="case-arrow">↗</div>
                            <div className="case-label">ЦКиМО</div>
                        </div>
                        <div className="card-content">
                            <p className="eyebrow">Наш опыт</p>
                            <h2>Наш опыт</h2>
                            <p>Мы внедрили методику в ЦКиМО: оптимизировали коммуникации с пациентами, сократили расходы
                                на SMS и начали переводить аудиторию в мессенджеры.</p>
                            <p>За счет изменений клиника получила дополнительный финансовый эффект без перестройки
                                текущих бизнес-процессов.</p>
                            <div className="button-row">
                                <a className="button button-primary" href="#contacts">Хочу обсудить</a>
                            </div>
                        </div>
                    </article>
                </div>
            </section>

            <ContactUs />
        </main>

        <footer className="site-footer">
            <div className="container footer-grid">
                <div>
                    <a className="brand footer-brand" href="#top">
                        <span className="brand-mark"><span>К</span><b>360</b><i></i></span>
                        <span className="brand-name">Контакт<span>360</span></span>
                    </a>
                    <p>Оптимизация коммуникаций<br/>с пациентами для клиник.<br/>Меньше затрат, больше<br/>пациентов,
                        выше прибыль.</p>
                </div>
                <nav className="footer-links">
                    <a href="#calculator">Калькулятор</a>
                    <a href="#reports">Отчеты</a>
                    <a href="#research">Исследование</a>
                    <a href="#contacts">Контакты</a>
                </nav>
                <div className="requisites">
                    <strong>ООО ЁРТАР</strong>
                    <span>ИНН 7000013186</span>
                    <span>КПП 701701001</span>
                    <span>ОГРН 1237000000000</span>
                </div>
                <div className="footer-contacts">
                    <a href="tel:+79996200146">☏ +7 (999) 620-01-46</a>
                    <a href="mailto:vmv@yourtar.ru">✉ vmv@yourtar.ru</a>
                    <span>⌖ г. Томск</span>
                </div>
            </div>
            <div className="container footer-bottom">© 2026 Контакт360. Все права защищены.</div>
        </footer>
    </div>
}

export default App;
